var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '../Button';
import Overlay from '../Overlay';
import Text from '../Text';
import { useRef } from 'react';
import { getActionButtonColors } from './getActionButtonColors';
import { getActionIcon } from './getActionIcon';
var ActionButton = function (props) {
    var icon = props.icon, label = props.label, onClick = props.onClick, _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.loading, loading = _b === void 0 ? false : _b, _c = props.variant, variant = _c === void 0 ? 'default' : _c;
    var ref = useRef();
    var canClick = Boolean(!loading && !disabled && onClick);
    var onButtonClick = function () {
        if (canClick)
            onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    var startIcon = icon;
    var conditionalButtonProps = getActionButtonColors(variant, loading);
    var actionIcon = getActionIcon(variant, !disabled && loading);
    var oppositeOverlay = ['success', 'selected'].includes(variant);
    if (ref.current) {
        if (canClick)
            ref.current.style.cursor = 'pointer';
        else
            ref.current.style.cursor = 'default';
    }
    return (_jsx(Button, __assign({}, conditionalButtonProps, { ref: ref, submit: false, label: undefined, onClick: onButtonClick, disabled: disabled, startIcon: _jsxs(_Fragment, { children: [canClick && (_jsx(Overlay, { style: { width: 'calc(100% + 4px)', height: 'calc(100% + 4px)', top: -2, left: -2 }, opposite: oppositeOverlay })), actionIcon !== null && actionIcon !== void 0 ? actionIcon : startIcon] }) }, { children: _jsx(Text, __assign({ variant: "body2Semibold", color: "neutral70" }, { children: label })) })));
};
export default ActionButton;
